import developmentEnv from './development'
import productionEnv from './production'
// todo требуется отрефакторить совместно с api, в зависимости от переменной окружения (BUILD_ENV), ump или .net
const environment = process.env.NODE_ENV === 'development' ? developmentEnv : productionEnv

export default environment
